import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    duplicateDisabledTooltipTitle: (isSimulation: boolean) => {
      const id = isSimulation
        ? 'orders.duplicate.disabled.simulations.title'
        : 'orders.duplicate.disabled.operations.title'
      return translate({ id })
    },

    duplicateDisabledTooltipSubtitle: (isSimulation: boolean, count: number) => {
      const id = isSimulation
        ? 'orders.duplicate.disabled.simulations.subtitle'
        : 'orders.duplicate.disabled.operations.subtitle'
      return translate({ id, values: { count } })
    },

    orderNotFoundError: translate({ id: 'orders.notFoundError' }),
  }))

  return api
}
